import { syncTone } from '../lib/format'
import type { ParkSummary } from '../lib/types'

interface Props {
  parks: ParkSummary[]
  loading: boolean
  error: string | null
  selected: string | null
  onSelect: (slug: string | null) => void
}

export default function Sidebar({ parks, loading, error, selected, onSelect }: Props) {
  return (
    <nav className="sidebar" aria-label="Parken">
      <button type="button" className="side-item" aria-current={selected === null} onClick={() => onSelect(null)}>
        <span className="row">
          <strong>Alle parken</strong>
          <span className="count">{parks.length || ''}</span>
        </span>
      </button>
      <div className="side-title">Parken</div>
      {loading && <div className="side-item muted small">Laden…</div>}
      {error && !loading && <div className="side-item inline-error small">{error}</div>}
      {!loading && !error && parks.length === 0 && <div className="side-item muted small">Nog geen parken.</div>}
      {parks.map((park) => (
        <button
          key={park.slug}
          type="button"
          className="side-item"
          aria-current={park.slug === selected}
          onClick={() => onSelect(park.slug)}
        >
          <span className="row">
            <strong>{park.name}</strong>
            <span className="count">{park.unitCount}</span>
          </span>
          <span className="muted small">{park.slug}</span>
          {park.integrations.length > 0 && (
            <span className="side-dots">
              {park.integrations.map((integration) => (
                <i key={integration.id} className={`dot ${syncTone(integration)}`} title={integration.label} />
              ))}
            </span>
          )}
        </button>
      ))}
    </nav>
  )
}
